import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { MapPin, ArrowUpRight } from "@phosphor-icons/react";

export default function ProjectCard({ project, hrefBase = "/p", index = 0 }) {
    const cover = project.cover_image || (project.images && project.images[0]);
    return (
        <Link
            to={`${hrefBase}/${project.id}`}
            data-testid={`project-card-${project.id}`}
            className="group block fade-in-up"
            style={{ animationDelay: `${index * 60}ms` }}
        >
            <div className="aspect-[4/3] bg-neutral-100 overflow-hidden border border-neutral-200">
                {cover ? (
                    <img
                        src={fileUrl(cover)}
                        alt={project.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-neutral-400 text-xs uppercase tracking-widest">
                        No photo
                    </div>
                )}
            </div>
            <div className="pt-4 flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <div className="text-overline text-neutral-500 mb-1">
                        {project.category || "Project"}
                    </div>
                    <h3 className="font-display text-xl font-bold leading-tight group-hover:text-[#E63946] transition-colors truncate">
                        {project.title}
                    </h3>
                    {project.location && (
                        <div className="flex items-center gap-1 text-xs text-neutral-600 mt-2">
                            <MapPin size={14} /> {project.location}
                        </div>
                    )}
                </div>
                <ArrowUpRight
                    size={22}
                    weight="bold"
                    className="opacity-30 group-hover:opacity-100 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all flex-shrink-0"
                />
            </div>
        </Link>
    );
}
